import React from 'react';
import Center from 'app/shared/modules/Center';
import Container from 'app/shared/core/Container';
import Row from 'app/shared/core/Row';
import Section from 'app/shared/modules/Section';
import 'app/shared/modules/mobile-apps/FeaturesSection.scss';
import Title from 'app/shared/modules/Title';

class FeaturesSection extends React.Component {
  render() {
    return (
      <div className="FeaturesSection">
        <Center>
          <Container>
            <Title size="lg">HotPads mobile app features</Title>
            <Section>
              <div className="FeaturesSection-description">
                <Title size="md">Location based search</Title>
                <Row>
                  <p>Use your current location or any US location to search for millions of rentals.</p>
                </Row>
              </div>
              <div className="FeaturesSection-pic location" />
            </Section>

            <Section>
              <div className="FeaturesSection-description">
                <Title size="md">Detailed results</Title>
                <Row>
                  <p>View a list of search results, click for more details, and mark your favorite listings.</p>
                </Row>
              </div>
              <div className="FeaturesSection-pic detailed-results" />
            </Section>

            <Section>
              <div className="FeaturesSection-description">
                <Title size="md">Saved searches</Title>
                <Row>
                  <p>Save your searches and choose the frequency at which you'll receive updates to that search.</p>
                </Row>
              </div>
              <div className="FeaturesSection-pic saved-search" />
            </Section>
          </Container>
        </Center>
      </div>
    );
  }
}

export default FeaturesSection;
